import cx from 'classnames';
import NextLink from 'next/link';

import {Button, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import * as css from '../CTACard/CTACard.css';

import {CTACardNarrowProps} from './CTACardNarrow.types';

import {
  CTACardNarrowHeading,
  CTACardNarrowLedeText,
  CTACardNarrowLedeTextBottomContent,
  CTACardNarrowWrapper,
  CTACardNarrowWrapperSecondary,
  CTACardNarrowWrapperTextTop,
} from './CTACardNarrow.css';

export const CTACardNarrow = ({
  href = '#',
  headline,
  lede,
  variants = 'primary',
  btnText,
  className,
  hasBtnIcon,
  btnColor,
  btnMarginTop,
  autoHeight,
}: CTACardNarrowProps) => {
  return (
    <NextLink passHref href={href || '#'}>
      <span
        className={cx(
          css.root({variant: autoHeight ? 'autoHeight' : 'primary'}),
          sprinkles({colSpan: [8, 8, 4]}),
          className,
        )}>
        <div
          className={
            variants === 'primary'
              ? CTACardNarrowWrapper
              : variants === 'secondary'
              ? CTACardNarrowWrapperSecondary
              : variants === 'textTop'
              ? CTACardNarrowWrapperTextTop
              : CTACardNarrowWrapperTextTop
          }>
          <div className={variants === 'textBottom' ? CTACardNarrowLedeTextBottomContent : ''}>
            {typeof headline === 'string' || typeof headline === 'number' ? (
              <Text as="h2" variant="heading2" color="white" className={CTACardNarrowHeading}>
                {headline}
              </Text>
            ) : (
              headline
            )}
            {typeof lede === 'string' || typeof lede === 'number' ? (
              <Text as="p" className={CTACardNarrowLedeText} color="white">
                {lede}
              </Text>
            ) : (
              lede
            )}
          </div>
          {variants === 'primary' ? (
            <Button
              className={sprinkles({display: ['flex']})}
              aria-hidden
              as="span"
              {...(!hasBtnIcon && {icon: 'ArrowRight'})}
              icon="ArrowRight"
              variant={btnColor ?? 'primary'}>
              {btnText}
            </Button>
          ) : (
            <Button
              className={sprinkles({
                display: ['flex'],
                mT: [btnMarginTop ? btnMarginTop : 'auto', 'auto'],
              })}
              aria-hidden
              as="span"
              {...(hasBtnIcon && {icon: 'ArrowRight'})}
              variant={btnColor ?? 'primary-dark'}>
              {btnText}
            </Button>
          )}
        </div>
      </span>
    </NextLink>
  );
};
